import { CircularProgress, Box } from "@mui/material";

const Loader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundColor: "#f9f9f9",
      }}
    >
      <CircularProgress size={60} thickness={4} color="primary" />
    </Box>
  );
};

export default Loader;
